import { getFlowInfo } from '@flows/src/api/getFlowInfo';
import { FLOWS_FINALIZE_PATH } from '@flows/src/FlowsFinalizeRouter';
import useFlowsInitNew from '@flows/src/hooks/init/useFlowsInitNew';
import useFlowsResetState from '@flows/src/hooks/useFlowsResetState';
import { SchemaYellowHiveProductsInConversationCmd } from 'wg-api-sdk';
import { useLocale } from '../../../../../i18n';

const useStartYellowhiveContractFlow = () => {
  const { initFlow } = useFlowsInitNew();
  const { userLang } = useLocale();
  const { reset } = useFlowsResetState();

  return async ({
    flowId,
    uuid,
    inputUrl,
    partyId,
    quoteId,
    quoteIds,
    yellowhive_products,
    next,
  }: {
    flowId?: string;
    next?: string;
    yellowhive_products: SchemaYellowHiveProductsInConversationCmd[];
    uuid?: string;
    inputUrl?: string;
    partyId?: string;
    quoteId?: string;
    quoteIds?: string[];
  }) => {
    reset();
    let _next = next;
    if (flowId) {
      const flowInfo = await getFlowInfo(flowId, { lang: userLang });
      _next = flowInfo.next;
    }
    await initFlow({
      flowId: _next || '',
      payload: {
        party_id: partyId,
        yellowhive_products,
        previous_session_id: uuid,
      },
      inputUrl,
      // Yellowhive should finalize on the Yellowhive finalization page
      outputUrl: `${FLOWS_FINALIZE_PATH}/yellowhive`,
      sessionId: uuid,
      shouldComplete: false,
    });
  };
};

export default useStartYellowhiveContractFlow;
